import { Component, ViewEncapsulation, Input, OnInit } from '@angular/core';

@Component({
    selector: 'tidy-marker',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./marker.component.scss'],
    template: `
    <span class="map-marker">
      {{text}}
    </span>
  `,
    standalone: false
})

export  class MarkerComponent implements OnInit {

  @Input() letter: string;
  alphabet = 'abcdefghijklmnopqrstuvwxyz';
  text: string;

  ngOnInit() {
    this.text = this.alphabet[this.letter];
  }

}
